import {Injectable} from '@angular/core';
import {ConnectionHttpService, ApiResourceLocation} from '@softline/core';
import {User} from '../data/user.model';
import {USER_RESOURCE_PATH} from '../registration-admin.api';
import { lastValueFrom } from "rxjs";

@Injectable()
export class UserResourceService {
  constructor(private service: ConnectionHttpService) {}

  async create(user: User): Promise<User> {
    const location: ApiResourceLocation = { path: USER_RESOURCE_PATH };
    return lastValueFrom(this.service.create<User, User>(location, user));
  }
}
